import { render } from "./LoadingSpinnerAntPanels.vue?vue&type=template&id=2c670748"
const script = {}

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vuecomponents/LoadingSpinnerAntPanels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c670748"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c670748', __exports__)) {
    api.reload('2c670748', __exports__)
  }
  
  module.hot.accept("./LoadingSpinnerAntPanels.vue?vue&type=template&id=2c670748", () => {
    api.rerender('2c670748', render)
  })

}


export default __exports__